import useI18nInstance from './useI18nInstance';

const useSetLanguage = (language: string) => {
  const i18nInstance = useI18nInstance();

  i18nInstance.changeLanguage(language);
};

export default useSetLanguage;
